export const ReportModalTestIds = {
  title: `REPORT_TITLE`,
  reason: `REPORT_REASON`,
  submit: `REPORT_SUBMIT`,
};
